import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuthentication from '../hooks/useAuthentication';

const ResetCompanySignup = () => {
    const navigate = useNavigate()
    const { updateUser } = useAuthentication();

    useEffect(() => {
        fetch('/v0/account/reset_agree_toc', {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: {}
        })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                updateUser(json.result);
                return navigate('/main')
            })
    }, [])


    return (<div />)
}

export default ResetCompanySignup
